import React from 'react';
import './App.css';
import Web3Provider from './Web3Provider/Web3Provider';
import Home from "./containers/Home/Home"

const App = () => {
  return (
    <div className='h-auto min-h-screen bg-black'>
   
        <Web3Provider>
         <Home/>
        </Web3Provider>
  
    </div>
  );
}

export default App;
